import { Injectable } from '@angular/core';
import { AlertService } from '@mapfre-design-library/src/public_api';
import { ErrorRedirectionService } from '../error-service/error-redirection.service';
import { ValidateEmailService } from '../signup-process-service/validate-email.service';

import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(
    private alertService: AlertService,
    private validateEmailService: ValidateEmailService,
    private errorRedirectionService: ErrorRedirectionService,
    private router: Router
  ) {}

  maskEmail(emailId) {
    const email = emailId.split('@');
    const email1 = email[0].split('').map((char, i) => {
      if (i > 1) {
        return '*';
      } else {
        return char;
      }
    });
    const com = email[1].split('.');
    const email2 = com[0].split('').map((chars, i) => {
      if (i > 1) {
        return '*';
      } else {
        return chars;
      }
    });

    return email1.join('') + '@' + email2.join('') + '.' + com[1];
  }

  maskEmailBeforeAt(emailId) {
    const email = emailId.split('@');
    const maskedEmailPart = "*".repeat(email[0].length);

    return maskedEmailPart + '@' + email[1];
  }

  sendEmail(emailId) {
    // Call sendValidationEmail for send Resent Verification mail form user email address
    this.validateEmailService
      .sendValidationEmailForNonCommercial(emailId)
      .subscribe(
        (resp) => {
          if (resp) {
            this.alertService.success('VERIFICATION_EMAIL_SENT');
            this.router.navigate(['/signup', 'validate-account']);
          }
        },
        (error) => {
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }
}
